export default function UserIsBot() {
	return /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
};